export default __webpack_public_path__ + "static/media/Bild4.22870c19.jpeg";